import { useLayoutEffect } from "react";
import { Navigate } from "react-router";
import { useMeDialog } from "@/lib/me-dialog";

/** 兼容旧链接 /me：打开个人中心弹窗并回到工作台首页。 */
export default function MePage() {
  const { openMe } = useMeDialog();

  useLayoutEffect(() => {
    openMe();
  }, [openMe]);

  return <Navigate to="/" replace />;
}
